import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Tournament } from '@src/lib/types';
import { TournamentState } from '@src/state/slices/types';

const initialState: TournamentState = {
  tournaments: {},
};

export const gameSlice = createSlice({
  name: 'tournament',
  initialState,
  reducers: {
    tournamentUpdated: (state, action: PayloadAction<Tournament>) => {
      const { payload } = action;
      state.tournaments[payload.tournamentId] = payload;
    },
    clearTournamentDetails: (state) => {
      state.tournaments = {};
    },
  },
});

export default gameSlice.reducer;

export const { tournamentUpdated, clearTournamentDetails } = gameSlice.actions;
